import { createNewLocation } from '../../../permissions/account';

export const customerDetailsActionList: any = [
  {
    label: 'general:actions.new_company',
    icon: '#icon-add',
    action: 'customerDetailsNewCompany',
    permissions: createNewLocation,
  },
  {
    label: 'general:actions.new_site',
    icon: '#icon-add',
    action: 'customerDetailsNewSite',
    permissions: createNewLocation,
  },
];

export const deliveryDetailsActionList: any = [
  {
    label: 'general:actions.new_company',
    icon: '#icon-add',
    action: 'deliveryDetailsNewCompany',
    permissions: createNewLocation,
  },
  {
    label: 'general:actions.new_site',
    icon: '#icon-add',
    action: 'deliveryDetailsNewSite',
    permissions: createNewLocation,
  },
];

export const genericActionList: any = [
  {
    label: 'general:actions.new_project',
    icon: '#icon-add',
    action: 'newProject',
    permissions: createNewLocation,
  },
  {
    label: 'general:actions.new_cost_center',
    icon: '#icon-add',
    action: 'newCostCenter',
    permissions: createNewLocation,
  },
];
